/**
 * Physical locations for the current user-owned account schema. No validation,
 * normalization or authorization happens here. Keep these paths compatible
 * with published clients; migrating storage is a separate change.
 */
export const accountPaths = {
    acceptedAccount: (actorId, accountId) => `users/${actorId}/acceptedUsers/${accountId}`,
    acceptedAccounts: (actorId) => `users/${actorId}/acceptedUsers`,
    account: (accountId) => `users/${accountId}`,
    application: (accountId, appId) => `users/${accountId}/applications/${appId}`,
    applications: (accountId) => `users/${accountId}/applications`,
    build: (accountId, appId, buildId) => `users/${accountId}/applications/${appId}/builds/${buildId}`,
    builds: (accountId, appId) => `users/${accountId}/applications/${appId}/builds`,
    deletedApplication: (accountId, appId) => `users/${accountId}/deletedApplications/${appId}`,
    invitation: (accountId, email) => `users/${accountId}/invitedUsers/${email}`,
    invitations: (accountId) => `users/${accountId}/invitedUsers`,
    release: (accountId, appId, releaseId) => `users/${accountId}/applications/${appId}/releases/${releaseId}`,
    releaseEvents: (accountId, appId) => `users/${accountId}/applications/${appId}/releaseEvents`,
    releases: (accountId, appId) => `users/${accountId}/applications/${appId}/releases`,
};
